import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class AnyDateTagHasNotAsteriskError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.numberings.validation.format.any-date-tag-has-not-asterisk');
    }
}
